
(function(){
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var canAnim = !reduce;
  if (canAnim) document.documentElement.classList.add("tsc-anim");

  function $(s,r){ return (r||document).querySelector(s); }
  function $$(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }

  /* ---------- toast ---------- */
  var toast = $("#toast"), tTimer;
  function say(msg){
    if (!toast) return;
    toast.textContent = msg; toast.classList.add("up");
    clearTimeout(tTimer); tTimer = setTimeout(function(){ toast.classList.remove("up"); }, 2200);
  }

  /* ---------- game rail: chips navigate, hover previews the game's colour ---------- */
  (function(){
    var chips = $$(".gamechip");
    if (!chips.length) return;
    var base = document.documentElement.getAttribute("data-game") || "house";
    chips.forEach(function(chip){
      chip.addEventListener("mouseenter", function(){
        document.documentElement.setAttribute("data-game", chip.dataset.g || "house");
      });
      chip.addEventListener("focus", function(){
        document.documentElement.setAttribute("data-game", chip.dataset.g || "house");
      });
    });
    var rail = document.querySelector(".rail-scroll");
    if (rail) {
      rail.addEventListener("mouseleave", function(){
        document.documentElement.setAttribute("data-game", base);
      });
    }
  })();

  /* ---------- holo card ---------- */
  (function(){
    var card = $("#holo");
    if (!card || reduce) return;
    var raf = null;
    function move(e){
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        card.style.setProperty("--ry", ((x - .5) * 26).toFixed(2) + "deg");
        card.style.setProperty("--rx", ((.5 - y) * 26).toFixed(2) + "deg");
        card.style.setProperty("--mx", (x * 100).toFixed(1) + "%");
        card.style.setProperty("--my", (y * 100).toFixed(1) + "%");
        /* rainbow sweep angle shifts with tilt — the poke-holo signature */
        card.style.setProperty("--holo-angle", (100 + (x - .5) * 70 + (y - .5) * 30).toFixed(1) + "deg");
      });
    }
    card.addEventListener("pointerenter", function(){ card.classList.add("is-live"); });
    card.addEventListener("pointermove", move);
    card.addEventListener("pointerleave", function(){
      card.classList.remove("is-live");
      card.style.setProperty("--rx","0deg"); card.style.setProperty("--ry","0deg");
      card.style.setProperty("--mx","50%");  card.style.setProperty("--my","50%");
      card.style.setProperty("--holo-angle","112deg");
    });
    card.addEventListener("focus", function(){
      card.style.setProperty("--ry","-11deg"); card.style.setProperty("--rx","7deg");
    });
    card.addEventListener("blur", function(){
      card.style.setProperty("--rx","0deg"); card.style.setProperty("--ry","0deg");
    });
  })();

  /* ---------- product photo slots (internal placeholder swap) ---------- */
  (function(){
    var input = $("#pcPhoto"), current = null;
    if (!input) return;
    $$("[data-photo]").forEach(function(art){
      art.addEventListener("click", function(){ current = art; input.click(); });
    });
    input.addEventListener("change", function(){
      var f = input.files && input.files[0];
      if (!f || !current) return;
      var r = new FileReader();
      r.onload = function(){
        var img = current.querySelector("img.photo");
        if (!img){
          img = document.createElement("img");
          img.className = "photo"; img.alt = "";
          current.appendChild(img);
        }
        img.src = r.result;
        current.classList.add("hasphoto");
        input.value = "";
      };
      r.readAsDataURL(f);
    });
  })();

  /* ---------- sealed filters ---------- */
  (function(){
    var grid = $("#pgrid");
    if (!grid) return;
    var cards = $$(".pc", grid);
    $$("[data-pf]").forEach(function(b){
      b.addEventListener("click", function(){
        $$("[data-pf]").forEach(function(x){ x.setAttribute("aria-pressed","false"); });
        b.setAttribute("aria-pressed","true");
        var f = b.dataset.pf, shown = 0;
        cards.forEach(function(c){
          var k = c.dataset.kind, txt = c.textContent;
          var ok = f === "all"
            || (f === "box"   && (k === "box" || k === "case" || k === "slab"))
            || (f === "etb"   && (k === "etb" || k === "tin"))
            || (f === "pack"  && (k === "pack" || k === "blister" || k === "bundle"))
            || (f === "stock" && txt.indexOf("in stock") > -1)
            || (f === "pre"   && txt.indexOf("Ships") > -1);
          c.style.display = ok ? "" : "none";
          if (ok) shown++;
        });
        say(shown + (shown === 1 ? " product" : " products"));
      });
    });
  })();


  /* ---------- singles finder ----------
     The real finder lives inside sections/tsc-finder.liquid, which renders from the
     assigned Shopify collection (#tsc-cards-data). The duplicate that used to live here
     ran on defer AFTER that inline script and overwrote #rows with invented card names —
     and it dereferenced #rows / #q / #clearQ with no null guard, which threw a TypeError
     on every page that is not the homepage and killed everything below it in this file. */

  /* ---------- command palette: real Shopify search ---------- */
  (function(){
    var modal = $("#cmdk");
    var input = $("#cmdkInput");
    var list  = $("#cmdkList");
    var opener = $("#openCmdk");
    /* #cmdk lives in sections/tsc-footer.liquid — on any page without it, bail out
       BEFORE touching anything, or the whole file dies with a TypeError. */
    if (!modal || !input || !list) return;

    var searchBase = modal.getAttribute("data-search-url") || "/search";
    var lastFocus = null, drawSeq = 0, drawTimer = null;

    function esc(v){
      return String(v == null ? "" : v)
        .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")
        .replace(/"/g,"&quot;").replace(/'/g,"&#39;");
    }
    function searchUrl(term){
      return searchBase + "?q=" + encodeURIComponent(term);
    }
    function goRow(term){
      return '<a class="cmdk-item" href="' + esc(searchUrl(term)) + '">' +
        '<span class="k">GO</span><span>Search for “' + esc(term) + '”</span></a>';
    }
    function submit(){
      var term = (input.value || "").trim();
      if (!term) return;
      window.location.href = searchUrl(term);
    }

    function draw(){
      var term = (input.value || "").trim();
      if (!term){
        list.innerHTML = '<div class="empty">Type a card, set or product name, then press Enter.</div>';
        return;
      }
      list.innerHTML = goRow(term);
      /* Shopify's own predictive-search endpoint — real catalogue data, never invented.
         If it is unavailable the "Search for ..." row above still works. */
      var seq = ++drawSeq;
      if (!window.fetch) return;
      fetch(searchBase + "/suggest.json?q=" + encodeURIComponent(term) +
            "&resources[type]=product&resources[limit]=6", { headers: { "Accept": "application/json" } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          if (seq !== drawSeq) return;
          var items = j && j.resources && j.resources.results && j.resources.results.products;
          if (!items || !items.length) return;
          /* Title + link only. suggest.json's `price` field is not a formatted money
             string, and printing a number we cannot vouch for is how the invented
             prices got onto this page in the first place. */
          list.innerHTML = items.map(function(pr){
            return '<a class="cmdk-item" href="' + esc(pr.url) + '">' +
              '<span class="k">CARD</span><span>' + esc(pr.title) + '</span></a>';
          }).join("") + goRow(term);
        })
        .catch(function(){});
    }

    function open(){
      lastFocus = document.activeElement;
      modal.setAttribute("open",""); input.value = ""; draw();
      setTimeout(function(){ input.focus(); }, 30);
    }
    function close(){
      drawSeq++;
      modal.removeAttribute("open");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (opener) opener.addEventListener("click", open);
    input.addEventListener("input", function(){
      clearTimeout(drawTimer);
      drawTimer = setTimeout(draw, 160);
    });
    input.addEventListener("keydown", function(e){
      if (e.key === "Enter"){ e.preventDefault(); submit(); }
    });
    modal.addEventListener("click", function(e){
      if (e.target.hasAttribute && e.target.hasAttribute("data-close")) close();
    });
    document.addEventListener("keydown", function(e){
      if ((e.metaKey || e.ctrlKey) && e.key && e.key.toLowerCase() === "k"){
        e.preventDefault(); modal.hasAttribute("open") ? close() : open();
      }
      if (e.key === "Escape" && modal.hasAttribute("open")) close();
    });
  })();

  /* ---------- delegated scroll ----------
     The [data-add] branch that used to live here is gone. It answered every click on a
     [data-add] element with a toast reading "Added — {name}" while never touching the
     cart: on a live store that told customers an item was in their basket when nothing
     had been added. Every call site (tsc-radar, tsc-buylist, tsc-sealed) is now a real
     link to a real destination, so there is nothing left to delegate. */
  document.addEventListener("click", function(e){
    var t = e.target;
    if (!t || typeof t.closest !== "function") return;
    var sc = t.closest("[data-scroll]");
    if (sc){ var el = $(sc.dataset.scroll); if (el) el.scrollIntoView({behavior: reduce ? "auto" : "smooth", block:"start"}); }
  });


  /* ---------- stage gating: run animations only while visible ---------- */
  (function(){
    if (!("IntersectionObserver" in window)) return;
    var stages = [$("#hero"), $("#chant")].filter(Boolean);
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ en.target.classList.toggle("onstage", en.isIntersecting); });
    }, { threshold: .05 });
    stages.forEach(function(el){ io.observe(el); });
  })();

  /* ---------- count-up stats (one-shot, rAF) ---------- */
  (function(){
    var nums = $$(".stat b[data-count]");
    if (!nums.length) return;
    function run(el){
      var target = parseInt(el.dataset.count, 10),
          pre = el.dataset.prefix || "", suf = el.dataset.suffix || "",
          t0 = null, dur = 900;
      function step(t){
        if (!t0) t0 = t;
        var k = Math.min((t - t0) / dur, 1);
        k = 1 - Math.pow(1 - k, 3);
        el.textContent = pre + Math.round(target * k) + suf;
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!canAnim){
      nums.forEach(function(el){ el.textContent = (el.dataset.prefix||"") + el.dataset.count + (el.dataset.suffix||""); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){ run(en.target); io.unobserve(en.target); }
      });
    }, { threshold: .5 });
    // Take the real numbers down to zero only now, when we know we are going to
    // animate them back up. The markup ships the true value so that everything
    // which never runs this script still reads the truth; zeroing at observe
    // time rather than in the markup means the count-up looks exactly as it did.
    nums.forEach(function(el){
      el.textContent = (el.dataset.prefix || "") + "0" + (el.dataset.suffix || "");
      io.observe(el);
    });
  })();

  /* ---------- drop countdowns (any .dropclock[data-deadline], editor-driven) ---------- */
  (function(){
    var clocks = $$(".dropclock[data-deadline]");
    if (!clocks.length) return;
    clocks.forEach(function(el){
      var raw = el.getAttribute("data-deadline");
      // accept "YYYY-MM-DD" (assume 10:00 local street time) or a full ISO string
      var iso = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw + "T10:00:00" : raw;
      var target = new Date(iso).getTime();
      if (isNaN(target)) { el.remove(); return; }
      var timer = null;
      function tick(){
        var d = target - Date.now();
        if (d <= 0){ el.textContent = "LIVE NOW"; if (timer){ clearInterval(timer); timer = null; } return; }
        var days = Math.floor(d/864e5), h = Math.floor(d%864e5/36e5),
            m = Math.floor(d%36e5/6e4), sec = Math.floor(d%6e4/1e3);
        el.textContent = days + "d " + String(h).padStart(2,"0") + ":" + String(m).padStart(2,"0") + ":" + String(sec).padStart(2,"0");
      }
      tick();
      if (!("IntersectionObserver" in window)){ timer = setInterval(tick, 1000); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting && !timer){ tick(); timer = setInterval(tick, 1000); }
          else if (!en.isIntersecting && timer){ clearInterval(timer); timer = null; }
        });
      }, { threshold: 0 });
      io.observe(el);
    });
  })();

  /* ---------- header elevation ---------- */
  (function(){
    var top = $(".top");
    if (!top) return;
    var raf = null;
    function onScroll(){
      if (raf) return;
      raf = requestAnimationFrame(function(){
        top.classList.toggle("scrolled", window.scrollY > 8);
        raf = null;
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  })();

})();

/* ══ WANTED CARDS — tilt in row + tap to open a crisp lightbox ══ */
(function(){
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var wrap = document.querySelector(".wanted");
  if(!wrap) return;
  var cards = Array.prototype.slice.call(wrap.querySelectorAll(".wcard"));
  if(!cards.length) return;
  var lb     = wrap.querySelector(".wlb");
  var lbCard = lb && lb.querySelector(".wlb-card");
  var lbImg  = lb && lb.querySelector(".wlb-img");
  var lbName = lb && lb.querySelector(".wlb-name");
  var lbNote = lb && lb.querySelector(".wlb-note");
  var lbBack = lb && lb.querySelector(".wlb-back-img");
  var TILT = 9;

  function openLB(card){
    if(!lb || !lbCard) return;
    var img  = card.getAttribute("data-img");
    var name = card.getAttribute("data-name") || "";
    var note = card.getAttribute("data-note") || "";
    lbCard.setAttribute("data-fx", card.getAttribute("data-fx") || "basic");
    lbCard.style.setProperty("--game", card.getAttribute("data-accent") || "#FFB627");
    if(img){ lbCard.classList.add("has-img"); lbImg.src = img; lbImg.alt = name; }
    else   { lbCard.classList.remove("has-img"); lbImg.removeAttribute("src"); }
    if(lbName) lbName.textContent = name;
    if(lbNote){ lbNote.textContent = note; lbNote.style.display = note ? "" : "none"; }
    var back = card.getAttribute("data-back");
    if(back && lbBack){ lbCard.classList.add("has-back"); lbBack.src = back; }
    else if(lbCard){ lbCard.classList.remove("has-back"); if(lbBack) lbBack.removeAttribute("src"); }
    lb.classList.add("open");
    lb.setAttribute("aria-hidden", "false");
  }
  function closeLB(){
    if(!lb) return;
    lb.classList.remove("open");
    lb.setAttribute("aria-hidden", "true");
  }

  cards.forEach(function(card){
    var inner = card.querySelector(".wcard-inner");
    if(!inner) return;
    if(!reduce){
      card.addEventListener("pointermove", function(e){
        var r = card.getBoundingClientRect();
        var px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        var py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
        inner.style.setProperty("--rx", ((0.5 - py) * TILT).toFixed(2) + "deg");
        inner.style.setProperty("--ry", ((px - 0.5) * TILT).toFixed(2) + "deg");
        card.style.setProperty("--mx", (px * 100).toFixed(1) + "%");
        card.style.setProperty("--my", (py * 100).toFixed(1) + "%");
        card.style.setProperty("--holo-angle", (px * 180).toFixed(1) + "deg");
      });
      card.addEventListener("pointerleave", function(){
        inner.style.setProperty("--rx","0deg"); inner.style.setProperty("--ry","0deg");
        card.style.setProperty("--mx","50%"); card.style.setProperty("--my","40%");
      });
    }
    inner.addEventListener("click", function(){ openLB(card); });
  });

  if(lb){
    Array.prototype.slice.call(lb.querySelectorAll("[data-wlb-close]")).forEach(function(el){
      el.addEventListener("click", closeLB);
    });
  }
  document.addEventListener("keydown", function(e){ if(e.key === "Escape"){ closeLB(); } });
})();
